<template>
    <div class="delivery-schedule-address__container container mx-auto text-center" :class="addressClass">
        <subscription-dropdown
            v-if="showDropdown"
            label="Delivery schedule for:"
            class="pb-4"/>

        <div v-else>
            <h5 class="uppercase mb-1" v-text="$t('DELIVERY_CARD_DELIVERY')"></h5>
            <p class="w-full sm:w-2/3 mx-auto">
                {{ address.address1 }}
            </p>
        </div>
    </div>
</template>

<script>
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'DeliveryScheduleAddress',
    components: {
        SubscriptionDropdown,
    },
    props: {
        address: {},
        showDropdown: {
            required: true,
            type: Boolean,
        },
        addressClass: {
            default: '',
            type: String,
        },
    },
};
</script>

<style lang="scss" scoped>
    .delivery-schedule-address__container {
        max-width: 500px;
    }
</style>
